import { Component, OnInit  } from '@angular/core';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NbTrigger } from '@nebular/theme';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
export interface Etiqueta {
  name: string;
}
@Component({
  selector: 'ngx-muroSocial-formativo',
  templateUrl: './muroSocial-formativo.component.html',
  styleUrls: ['./muroSocial-formativo.component.scss'],
  providers: [UtilidadesService,PeticionesHttpBackEndService]
})

export class MuroSocialFormativoComponent implements OnInit {

  galleryOptions: NgxGalleryOptions[];
  galleryOptionsComentarios: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  
  parametrosUrl: any;
  Token: any;
  usuario:any;
  etiqueta: Etiqueta[];
  selectable: boolean;
  removable: boolean;
  longitudEtiquetas: number;
  avisoEtiquetaMax: boolean;
  etiquetaValid: String;
  addOnBlur: boolean;
  openModal: any;
  datosSocial:any;
  cita:any;
  biografia:any;
  lopdCheck:any;
  tiposEtiquetas:any;
  imagenUser:any;
  resultado:any;
  position: String;
  etiquetaSeleccionadaInfo:any;
  etiquetaSeleccionadaInfoFiltrado:any;
  buscarEtiqueta:any;
  etiquetasUsuarios:any;
  etiquetas:any;
  showEtiquetas:boolean;
  modelPublicacion:any;
  resultadoMuroMensajes:any;
  listMensajes:any;
  listComentarios:any;
  seguidores:any;
  usuariosLikes:any;
  tituloModal:any;
  usuariosSegu:any;
  modelUnicamente:any;
  documentosPublicacion:any;
  documentosPublicacionCopia:any;
  usuarioEntidadComprobar:any;
  msgError:boolean;
  numeroPagina:number;
  actividadId:any;
  nombreActividad:any;
  usuariosParticipantes:any;
  msgErrorArea:boolean;
  busquedaActivada:boolean;
  busquedaGeneral:any;



  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  readonly separatorKeysCodes2: number[] = [ENTER, COMMA];
  constructor(private _route: ActivatedRoute, private utilidades: UtilidadesService, public _http: PeticionesHttpBackEndService,private router:Router,private modalService: NgbModal){
    _route.queryParams.subscribe(params => {
      this.parametrosUrl = params || null;
      this.actividadId = this.parametrosUrl.ac;
    });
    this.Token = JSON.parse(localStorage.getItem('auth_app_token'));
    this.etiqueta = [];
    this.selectable = true;
    this.removable = true;
    this.longitudEtiquetas = 0;
    this.avisoEtiquetaMax = false;
    this.etiquetaValid = "";
    this.addOnBlur = true;
    this.position = "right";
    this.etiquetasUsuarios = [];
    this.etiquetas = [];
    this.showEtiquetas = false;
    this.modelPublicacion = "";
    this.resultadoMuroMensajes = [];
    this.listMensajes = []
    this.listComentarios = [];
    this.usuariosLikes = [];
    this.usuariosSegu = [];
    this.seguidores = {"Seguidos":0,"Seguidores":0};
    this.tituloModal = "";
    this.modelUnicamente = false;
    this.documentosPublicacion = [];
    this.usuarioEntidadComprobar = 0;
    this.msgError = false;
    this.numeroPagina = 0;
    this.nombreActividad = "";
    this.usuariosParticipantes = [];
    this.msgErrorArea = false;
    this.documentosPublicacionCopia = [];
    this.busquedaActivada = false;
    this.busquedaGeneral = "";

  }
  open(content) {
    this.openModal = this.modalService.open(content);
  }

  galleryAction:any;
  actionButtonClicked(event,i) {
    this.galleryImages.splice(i, 1);
    this.documentosPublicacion.splice(i,1);
    
}
  ngOnInit() {
    if(this.actividadId !== null && this.actividadId !== undefined){
      this.actionButtonClicked = this.actionButtonClicked.bind(this);
      this.showEtiquetas = false;
      this.galleryAction = [{ icon: "fas fa-times-circle", onClick: this.actionButtonClicked }];
      this.galleryOptions = [
        { "imagePercent": 80,"width": "100%", "thumbnailsPercent": 20, "thumbnailsColumns": 6, "thumbnailsMargin": 0, "thumbnailMargin": 0,"thumbnailActions": this.galleryAction },
        { "breakpoint": 500, "width": "300px", "height": "300px", "thumbnailsColumns": 3,"thumbnailActions": this.galleryAction },
        { "breakpoint": 300, "width": "100%", "height": "200px", "thumbnailsColumns": 2,"thumbnailActions": this.galleryAction }
        ];
      this.galleryImages = [ ];
      this.galleryOptionsComentarios = [
      { "image": false, "height": "100px","width":"100%" },
      { "breakpoint": 500, "width": "100%" }
      ];
      this._http.getUsuario().subscribe(
        result => {
          this.usuario = result;
          this.usuarioEntidadComprobar = this.usuario.Entidad._entidad_id;
         this.recuperarMensajes(this.actividadId);
        }
      );
    }else{
      this.utilidades.notificationWarning("Aviso","No se puede recuperar los datos","top-left");
    }
   

  }


  recuperarMensajes(activitadId){
    this.resultadoMuroMensajes = [];
    //this.listMensajes = [];
    this.listComentarios = [];
    this._http.getOneReg("v1/getMuroMensajesFormativos",this.usuario.Entidad._entidad_id+"/"+activitadId+"/"+this.numeroPagina).subscribe(
      result => {
        let resultados :any = result;
        if(resultados.Code == 200){
       this.resultadoMuroMensajes = resultados.MurosMensajes;

       this.nombreActividad = resultados.NombreActividad;
       this.usuariosParticipantes = resultados.Participantes;
       this.imagenUser = resultados.ImagenUrl;
      // this.seguidores = resultados.ListaSeguidores[0];
       this.resultadoMuroMensajes.forEach(element => {
        if (element.Etiquetas !== null && element.Etiquetas !== undefined && element.Etiquetas !== "") {
          let et = element.Etiquetas.split(";");
          element.Etiquetas = [];
          et.forEach(x => {
            if (x.trim() !== "") {
              element.Etiquetas.push({ name: x.trim() });
            }
          });
        }else{
          element.Etiquetas = [];
        }
         if(element.Adjunto == undefined && element.Adjunto == null){
          element.Adjunto = [];
         }else{
          element.Adjunto.forEach(elementAdjunto => {
            let position = elementAdjunto.type.indexOf('.');
            if(position !== -1){
              elementAdjunto.type = "application/"+elementAdjunto.type.substring(position+1);

            }
          });
         }
          if(element.MuroMensajeLikeId !== null && element.MuroMensajeLikeId !== undefined){
              let et = element.MuroMensajeLikeId.split(";");
              let id = et.find( t => t+"" === this.usuario.Entidad._entidad_id+"");
              element.likeSeleccionado = id !== undefined ? true : false;
              element.MuroMensajeLikeId = et.length;
            }else{
              element.MuroMensajeLikeId = 0;
            }
            element.comentariosActivados = false;
            element.comentarMensaje = false;
            element.numeroComentario = element.NumeroComentario !== null && element.NumeroComentario !== undefined ? element.NumeroComentario : 0;
            element.Comentarios = [];
          this.listMensajes.push(element)
         
       });
       /*this.listMensajes.forEach(elementMensajes => {
         if(elementMensajes.MuroMensajeLikeId !== null && elementMensajes.MuroMensajeLikeId !== undefined){
          let et = elementMensajes.MuroMensajeLikeId.split(";");
          let id = et.find( t => t+"" === this.usuario.Entidad._entidad_id+"");
          elementMensajes.likeSeleccionado = id !== undefined ? true : false;
          elementMensajes.MuroMensajeLikeId = et.length;
         }else{
          elementMensajes.MuroMensajeLikeId = 0;
         }
         elementMensajes.comentariosActivados = false;
         elementMensajes.comentarMensaje = false;
         elementMensajes.numeroComentario = elementMensajes.NumeroComentario;
        elementMensajes.Comentarios = [];
         this.listComentarios.forEach(elementComentarios => {
          if(elementMensajes.MuroMensajeId == elementComentarios.MuroMensajeId){
            elementMensajes.Comentarios.push(elementComentarios);
          }
         });
       });*/
      }else{
        this.msgErrorArea = true;
        this.utilidades.notificationWarning("Aviso",resultados.Mensaje,"top-left");
      }
      });
  }


  selectedFile:File;
  handleFileInput(event,abrirModal:boolean,modal){
    this.selectedFile = event.target.files[0];
    var file:File = event.target.files[0];
    if(abrirModal){
      this.documentosPublicacion = [];
    }
      if((file.type).toString().indexOf("application/") !== -1){
       
        this.documentosPublicacion.push(this.selectedFile);

      }else{
        this.utilidades.notificationWarning("Aviso","Solo puede subir archivos","top-left");
      }
    if(abrirModal){
      this.modalCrear(modal,false);
    }
 
    }

    verArchivo(archivo){
          let cadena =  archivo.type;
         const linkSource = 'data:'+cadena+';base64,' + archivo.base64;
          const downloadLink = document.createElement("a");
          let nombre = archivo.nombre !== undefined ? archivo.nombre : "Doc";
          const fileName = nombre;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();        
    }


    filtrar_acentos(input){

      var acentos = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç";
      var original = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";
      for (var i = 0; i < acentos.length; i++) {
          input = input.replace(acentos.charAt(i), original.charAt(i)).toLowerCase();
      };
      return input;
 }
 infoPulsada(evento){
   this.etiquetaSeleccionadaInfo = JSON.parse(JSON.stringify(evento));
   this.etiquetaSeleccionadaInfoFiltrado = JSON.parse(JSON.stringify(evento));
   this.buscarEtiqueta = "";
 }


  buscar(){
    this.etiquetaSeleccionadaInfoFiltrado = JSON.parse(JSON.stringify(this.etiquetaSeleccionadaInfo))
    if(this.buscarEtiqueta !== ""){
      this.etiquetaSeleccionadaInfoFiltrado.textoDefinido = [];
      this.etiquetaSeleccionadaInfo.textoDefinido.forEach(element => {
        if(this.filtrar_acentos(element.name).indexOf(this.filtrar_acentos(this.buscarEtiqueta)) !== -1){
          this.etiquetaSeleccionadaInfoFiltrado.textoDefinido.push(element);
        }
      });
    }

  
  }

  modalCrear(content,avisoEliminar) {
    this.showEtiquetas = false;
    this.etiqueta = [];
    this.galleryImages = [];
    //this.documentosPublicacion = [];
    this.modelPublicacion = "";
    if(avisoEliminar){
      this.documentosPublicacion = [];
    }
    this.openModal = this.modalService.open(content, {size: 'lg'});
  }

  /**
   * Añadir etiqueta
   * @param event 
   */
  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.etiqueta.push({ name: value.trim() });
      this.longitudEtiquetas += value.length;
      if (this.longitudEtiquetas >= 500) {
        this.avisoEtiquetaMax = true;
        this.etiquetaValid = this.avisoEtiquetaMax ? "border-dangerC" : "";
      }
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }
  /**
   * Eliminar etiqueta
   * @param etiqueta 
   */
  remove(etiqueta: Etiqueta): void {
    const index = this.etiqueta.indexOf(etiqueta);

    if (index >= 0) {
      this.etiqueta.splice(index, 1);
      this.longitudEtiquetas -= etiqueta.name.length;
      if (this.longitudEtiquetas <= 500) {
        this.avisoEtiquetaMax = false;
        this.etiquetaValid = this.avisoEtiquetaMax ? "border-dangerC" : "";
      }
    }
  }
  filtrarPorEtiqueta(etiqueta: any){
    let nombreEtiqueta = etiqueta.name !== undefined ? etiqueta.name : etiqueta.Texto;
    window.open('#/private/muro-personal?formatE='+nombreEtiqueta,"_blank")
  }
  mostrarEtiquetas(mostrarModal:boolean,evento){
    if(mostrarModal){
      this.modalCrear(evento,true);
    }
    this.showEtiquetas = true;
  }

  cerrarModal(){
    this.showEtiquetas = false;
    this.galleryImages = [ ];
    this.documentosPublicacion = [];
    this.etiqueta = [];
    this.modelPublicacion = "";
    this.longitudEtiquetas = 0;
    this.openModal.close();
  }

  comentarioActivado(evento){
    if(evento.Comentarios.length == 0){
    this._http.getOneReg("v1/getComentariosMuros",this.usuario.Entidad._entidad_id+"/"+this.usuario.Entidad._entidad_id+"/"+evento.MuroMensajeId).subscribe(
      result => {
        let resultados :any = result;
        if(resultados.Code == 200){
       resultados.MurosComentarios.forEach(element => {
        if(element.MuroComentarioLikeId !== null && element.MuroComentarioLikeId !== undefined){
          let et = element.MuroComentarioLikeId.split(";");
          let id = et.find( t => t+"" === this.usuario.Entidad._entidad_id+"");
          element.likeSeleccionado = id !== undefined ? true : false;
          element.MuroComentarioLikeId = et.length;
        }else{
          element.MuroComentarioLikeId = 0;
        }
        evento.Comentarios.push(element);
       });
      }else{
        this.utilidades.notificationWarning("Aviso",resultados.Mensaje,"top-left");
      }
      });
    }
    evento.comentariosActivados = !evento.comentariosActivados;
  }

  meGustasActivado(evento,modal){
    this.usuariosLikes = [];
    this._http.getOneReg("v1/getLikesMensajes",evento.MuroMensajeId + "/"+this.usuario.Entidad._entidad_id+ "/"+this.usuarioEntidadComprobar).subscribe(
      result => {
      let resultado:any = result;
      if(resultado.Code == 200){
        this.usuariosLikes = resultado.LikesMensajes;
        if(this.usuariosLikes.length > 0){
          this.tituloModal = "Me gustas";
          this.openModal = this.modalService.open(modal, {size: 'sm'});
        }
      }else{
        this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
      }
    });
  }
  modalSeguidores(modal,tipo:number){
    this.usuariosSegu = [];
    this._http.getOneReg("v1/getSeguidores",this.usuario.Entidad._entidad_id + "/"+tipo+ "/"+this.usuarioEntidadComprobar).subscribe(
      result => {
      let resultado:any = result;
      if(resultado.Code == 200){
        this.usuariosSegu = resultado.ListSeguidores;
        if(this.usuariosSegu.length > 0){
          this.tituloModal = tipo == 1 ? "Seguidores" : "Seguidos";
          this.openModal = this.modalService.open(modal, {size: 'sm'});
        }
      }else{
        this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
      }
      });
      
  }

  comentarMensaje(mensaje){
    mensaje.comentarMensaje = !mensaje.comentarMensaje;
  }
  enviarComentario(mensaje){
    this._http.insertaObjecto("v1/actualizarComentarios", {
      Data: {
        "entidadId": this.usuario.Entidad._entidad_id, 
        "muroMensajeId": mensaje.MuroMensajeId, 
        "comentario": mensaje.modelComentario,
        "entidadVisor": this.usuario.Entidad._entidad_id, 
      }
    }).subscribe(
      result => {
        let resultado: any = result;
        if(resultado.Code == 200){
          this.comentarioActivado(mensaje);
          if(mensaje.Comentarios.length !== 0){
            resultado.Comentario[0].MuroComentarioLikeId = 0;
            mensaje.Comentarios.unshift(resultado.Comentario[0]);
          }
          mensaje.comentariosActivados = true;
          mensaje.modelComentario = "";
          mensaje.comentarMensaje = false;
          mensaje.numeroComentario = Number(mensaje.numeroComentario)+1;
        }else{
          this.utilidades.notificationWarning("Aviso",resultado.mensaje,"top-left");
        }
  
      },
      error => {
      }
    );
  }
  likeMensaje(mensaje,eventoEliminar){
    this._http.insertaObjecto("v1/actualizarLikes", {
      Data: {
        "entidadId": this.usuario.Entidad._entidad_id, 
        "muroMensajeId": mensaje.MuroMensajeId,
        "eliminarLike":eventoEliminar 
      }
    }).subscribe(
      result => {
        let resultado: any = result;
        if(resultado.Code == 200){
          mensaje.MuroMensajeLikeId = resultado.MurosMensajesLikes;
          mensaje.likeSeleccionado = !eventoEliminar;
        }else{
          this.utilidades.notificationWarning("Aviso",resultado.mensaje,"top-left");
        }
      },
      error => {
      }
    );
  }
  likeComentario(comentario,eventoEliminar){
    this._http.insertaObjecto("v1/actualizarLikesComentarios", {
      Data: {
        "entidadId": this.usuario.Entidad._entidad_id, 
        "muroComentarioId": comentario.MuroComentarioId,
        "eliminarLike":eventoEliminar 
      }
    }).subscribe(
      result => {
        let resultado: any = result;
        if(resultado.Code == 200){
          comentario.MuroComentarioLikeId = resultado.MurosMensajesLikes;
          comentario.likeSeleccionado = !eventoEliminar;
        }else{
          this.utilidades.notificationWarning("Aviso",resultado.mensaje,"top-left");
        }
      },
      error => {
      }
    );
  }

  meGustasComentariosActivado(evento,modal){
    this.usuariosLikes = [];
    this._http.getOneReg("v1/getLikesComentarios",evento.MuroComentarioId + "/"+this.usuario.Entidad._entidad_id+ "/"+this.usuarioEntidadComprobar).subscribe(
      result => {
      let resultado:any = result;
      if(resultado.Code == 200){
        this.usuariosLikes = resultado.LikesMensajes;
        if(this.usuariosLikes.length > 0){
          this.tituloModal = "Me gustas";
          this.openModal = this.modalService.open(modal, {size: 'sm'});
        }
      }else{
        this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
      }
    });
  }
  onScroll(){
    this.numeroPagina += 15;
    this.recuperarMensajes(this.actividadId);
  }
  crearNuevaPublicacion(){
    if(this.modelPublicacion !== null  && this.modelPublicacion !== undefined && this.modelPublicacion !== ""){
      if(this.modelPublicacion.length <= 800){
        const formData = new FormData();
        for (var i = 0; i < this.documentosPublicacion.length; i++) {
          formData.append('file'+i,this.documentosPublicacion[i]);
        }
        this._http.uploadFilePublicaciones(formData,this.usuario.Entidad._entidad_id)
        .subscribe(res => {
          let resultado:any = res;
  

          this._http.insertaObjecto("v1/updateMensajesFormativo",{Data: {"entidadId":this.usuario.Entidad._entidad_id,"actividadId":this.actividadId,"mensaje":this.modelPublicacion,"archivos":resultado.Archivos,"etiquetas":this.etiqueta}}).subscribe(
            result => {
              let resultado2 :any = result;
              if(resultado2.Code == 200){
                //this.utilidades.notificationSuccess("Aviso",resultado2.Mensaje,"top-left");
                resultado2.MurosMensajes.forEach(element => {
                  if (element.Etiquetas !== null && element.Etiquetas !== undefined && element.Etiquetas !== "") {
                    let et = element.Etiquetas.split(";");
                    element.Etiquetas = [];
                    et.forEach(x => {
                      if (x.trim() !== "") {
                        element.Etiquetas.push({ name: x.trim() });
                      }
                    });
                  }else{
                    element.Etiquetas = [];
                  }
                   if(element.Adjunto == undefined && element.Adjunto == null){
                    element.Adjunto = [];
                   }else{
                    element.Adjunto.forEach(elementAdjunto => {
                      let position = elementAdjunto.type.indexOf('.');
                      if(position !== -1){
                        elementAdjunto.type = "application/"+elementAdjunto.type.substring(position+1);
          
                      }
                    });
                   }
                    if(element.MuroMensajeLikeId !== null && element.MuroMensajeLikeId !== undefined){
                        let et = element.MuroMensajeLikeId.split(";");
                        let id = et.find( t => t+"" === this.usuario.Entidad._entidad_id+"");
                        element.likeSeleccionado = id !== undefined ? true : false;
                        element.MuroMensajeLikeId = et.length;
                      }else{
                        element.MuroMensajeLikeId = 0;
                      }
                      element.comentariosActivados = false;
                      element.comentarMensaje = false;
                      element.numeroComentario = element.NumeroComentario;
                      element.Comentarios = [];
                      this.listMensajes.unshift(element)
                 });
                this.openModal.close();
                if(resultado.ArchivosLimites.length > 0){
                  let archivosNoSubidos = "";
                  resultado.ArchivosLimites.forEach(element => {
                    archivosNoSubidos += " / "+element;
                  });
                  this.utilidades.notificationWarning("Aviso","Los siguientes archivos superan los 2MB y no pueden subirse"+archivosNoSubidos,"top-left");
      
                }
              }else{
                this.utilidades.notificationWarning("Aviso",resultado2.Mensaje,"top-left");
              }
            },
            error => {
            }
          );
        });
      }else{
        let mens = this.modelPublicacion.length >= 800 ?  "El mensaje no puede superar los 800 caracteres" : "Las etiquetas no pueden superar los 500 caracteres";
        this.utilidades.notificationWarning("Aviso",mens,"top-left");

      }
    }else{
      this.utilidades.notificationWarning("Aviso","Debe escribir un mensaje","top-left");
    }
  }

  seguirUsuario(seguidor,seguido,borrar){
  this._http.insertaObjecto("v1/updateSeguidores",{Data: {"entidadId":this.usuario.Entidad._entidad_id,"seguidorId":seguidor,"seguidoId":seguido,"borrar": borrar}}).subscribe(
          result => {
            let resultado :any = result;
            if(resultado.Code == 200){
              //this.utilidades.notificationSuccess("Aviso",resultado.Mensaje,"top-left");
              /*this.listMensajes = [];
              if(this.openModal !== undefined){
                this.openModal.close();
              }
              if (this.actividadId !== null && this.actividadId !== undefined) {
                this.recuperarMensajes(this.actividadId);
              } */
              this.listMensajes.forEach(elementMensajes => {
                if(elementMensajes.EntidadCreadoraId == seguido && !borrar){
                  elementMensajes.Seguido = "1";
                }
                if(elementMensajes.EntidadCreadoraId == seguido && borrar){
                  elementMensajes.Seguido = "0";
                }
               elementMensajes.Comentarios.forEach(elementComentarios => {
                 if(elementComentarios.EntidadCreadoraId == seguido && !borrar){
                  elementComentarios.Seguido = "1";
                 }
                 if(elementComentarios.EntidadCreadoraId == seguido && borrar){
                  elementComentarios.Seguido = "0";
                 }
                });
              });
              this.usuariosSegu.forEach(element => {
                if(element.EntidadId == seguido && !borrar){
                  element.Seguido = "1";
                }
                if(element.EntidadId == seguido && borrar){
                  element.Seguido = "0";
                }
              });
              this.usuariosLikes.forEach(element => {
                if(element[0]._entidad_id._entidad_id == seguido && !borrar){
                  element.Seguido = "1";
                }
                if(element[0]._entidad_id._entidad_id == seguido && borrar){
                  element.Seguido = "0";
                }
              });
            }else{
              this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
            }
          },
          error => {
          }
        );
  }

  navegarPaginaUsuario(usuarioMuro){
    if(this.openModal !== undefined){
      this.openModal.close();
    }
    let parametros: NavigationExtras = {
      queryParams: { 'uM': usuarioMuro}
    };
    this.router.navigate(['private/muro-usuarios'],parametros);
  }

  eliminarDocumento(i) {
    this.documentosPublicacion.splice(i,1);
    
}

buscarActivado(){
  this.busquedaActivada = !this.busquedaActivada;
}

onSearch(){
  let parametros: NavigationExtras = {
    queryParams: { 'nom': this.busquedaGeneral }
  };
  this.router.navigate(['private/buscador'], parametros);
}

eliminarMensaje(evento){
  this._http.insertaObjecto("v1/deleteMuroMensaje", {
    Data: {
      "entidadId": this.usuario.Entidad._entidad_id, 
      "muroMensajeId": evento.MuroMensajeId
    }
  }).subscribe(
    result => {
      let resultado: any = result;
      if(resultado.Code == 200){
        this.numeroPagina = 0;
        this.listMensajes = [];
        this.listComentarios = [];
        this.recuperarMensajes(this.actividadId);
        this.utilidades.notificationSuccess("Exito",resultado.Mensaje,"top-left");

      }else{
        this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
      }

    },
    error => {
    }
  );
}

eliminarComentario(evento,mensajes){
  this._http.insertaObjecto("v1/deleteMuroComentarios", {
    Data: {
      "entidadId": this.usuario.Entidad._entidad_id, 
      "muroComentarioId": evento.MuroComentarioId
    }
  }).subscribe(
    result => {
      let resultado: any = result;
      if(resultado.Code == 200){
        let id = mensajes.Comentarios.find( t => t.MuroComentarioId+"" === evento.MuroComentarioId+"");
        var indice = mensajes.Comentarios.indexOf(id);
        mensajes.Comentarios.splice(indice, 1);
        mensajes.numeroComentario = Number(mensajes.numeroComentario)-1;
        this.utilidades.notificationSuccess("Exito",resultado.Mensaje,"top-left");

      }else{
        this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
      }

    },
    error => {
    }
  );
}

 
}